// extracted by mini-css-extract-plugin
module.exports = {"root":"_22d5c0","title":"_bb2b7d","button":"_d2a39f"};